<template>
    <nav-tabs :exact="false" :tabs="tabs" />
    <router-view></router-view>
</template>

<script>
import NavTabs from "../../components/layouts/NavTabs.vue";
import PermissionMixin from "../../mixins/PermissionMixin.vue";
import { mapState } from "pinia";
import { Store } from "../../stores/store";

export default {
    components: { NavTabs },
    mixins: [PermissionMixin],
    
    data() {
        return {
            tabs: [
                { label: 'Motivos de recusa', route: 'reasons' },
                { label: 'Termos jurídicos', route: 'legal-terms' },
                { label: 'Ativações Gerais', route: 'platform-settings' },
            ]
        };
    },
    
    computed: {
        ...mapState(Store, ['permissions'])
    },

    watch: {
        permissions() {
            this.updateTabs();
        }
    },

    mounted() {
        this.updateTabs();
    },

    methods: {
        updateTabs() {
            this.tabs = [
                { label: 'Motivos de recusa', route: 'reasons' },
                { label: 'Termos jurídicos', route: 'legal-terms' },
                { label: 'Ativações Gerais', route: 'platform-settings' },
            ];

            if (this.hasPermission('view.feature_flags')) {
                this.tabs.push({ label: 'Feature Flags', route: 'feature-flags' });
            }

            if (this.hasPermission('view.lead_routing')) {
                this.tabs.push({ label: 'Roteamento de Leads', route: 'lead-routing' });
            }
        }
    }
}
</script>
